<template>
  <div
    style="
      height: 100vh;
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: space-between;
      max-width: 500px;
    "
    class="mx-auto elevation-7"
  >
    <div
      style="flex-grow: 13; overflow-y: auto; height: 100%"
      class="Kanit pa-4 mx-auto"
    >
      <div style="font-weight: bold; font-size: 22px">Term & Condition</div>
      <div>
        <ol>
          <li>
            สำนักงานส่งเสริมเศรษฐกิจดิจิทัล (depa)
            จะขอดำเนินการจัดเก็บข้อมูลเกี่ยวกับการขอรับการช่วยเหลือหรืออุดหนุน
            ภายใต้มาตรการช่วยเหลือหรือการอุดหนุนของสำนักงานส่งเสริมเศรษฐกิจดิจิทัล
            (depa) รวมไปถึงกิจกรรมต่างๆ ของสำนักงานฯ
            พร้อมทั้งการส่งแจ้งเตือนเพื่อให้ท่านได้รับข้อมูลข่าวสาร นัดหมาย
            และติดตามการดำเนินงานต่างๆ ของสำนักงานฯ
            โดยท่านจะได้รับความคุ้มครองตาม พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล พ.ศ.
            2562
          </li>
          <li>
            ข้าพเจ้าขอให้ สำนักงานส่งเสริมเศรษฐกิจดิจิทัล (depa)
            ดำเนินการเกี่ยวกับการขอรับการช่วยเหลือหรืออุดหนุน
            ภายใต้มาตรการช่วยเหลือหรือการอุดหนุนของสำนักงานส่งเสริมเศรษฐกิจดิจิทัล
            (depa) รวมไปถึงกิจกรรมต่างๆ ของสำนักงานฯ
            ให้แก่ข้าพเจ้าจนกว่าข้าพเจ้าจะยกเลิกการขอรับการช่วยเหลือหรืออุดหนุน
            รวมไปถึงการกิจกรรมต่างๆ ของสำนักงานฯ
          </li>
          <li>
            ข้าพเจ้ายอมรับ
            และตกลงว่าบรรดข้อมูลส่วนบุคคลและข้อมูลทั้งหมดที่ระบุไว้ในคำขอของระบบนี้เป็นข้อมูลที่ถูกต้องตามความเป็นจริง
            สำนักงานฯ
            ขอสงวนสิทธิ์ในการให้สิทธิประโยชน์หรือยกเลิกสิทธิประโยชน์กรณีที่ตรวจสอบพบว่าข้อมูลดังกล่าวไม่ตรงกับความเป็นจริง
          </li>
          <li>
            ข้าพเจ้ายอมรับ
            และตกลงว่าบรรดาข้อมูลส่วนบุคคลและข้อมูลทั้งหมดที่ระบุไว้ในคำขอของระบบนี้หรือที่เกิดจากการทำธุรกรรมของข้าพเจ้านั้นเป็นทรัพย์สินของสำนักงานฯ
          </li>
          <li>
            วัตถุประสงค์ในการเก็บข้อมูลส่วนบุคคลและข้อมูลอื่นๆ ดังกล่าวข้างต้น
            เพื่อใช้ข้อมูลดังกล่าวให้สอดคล้องกับวัตถุประสงค์ในการขอรับการช่วยเหลือหรืออุดหนุน
            ภายใต้มาตรการช่วยเหลือหรือการอุดหนุนของสำนักงานส่งเสริมเศรษฐกิจดิจิทัล
            (depa) รวมไปถึงกิจกรรมต่างๆ ของสำนักงานฯ
            และให้เกิดประโยชน์สูงสุดแก่ข้าพเจ้า
            โดยการใช้ข้อมูลส่วนบุคคลและข้อมูลดังกล่าว
            จะอยู่ในขอบข่ายและหลักเกณฑ์ที่สำนักงานฯ กำหนด
          </li>
          <li>
            ข้าพเจ้ายินยอมและมอบหมายให้สำนักงานฯ ใช้
            หรือแลกเปลี่ยนข้อมูลส่วนบุคคลของข้าพเจ้าซึ่งได้ให้ไว้ในคำขอของระบบนี้
            หรือได้รับจากการทำธุรกรรมกับสำนักงานฯ
            ให้แก่บุคคลอื่นในลักษณะที่เห็นว่าเป็นประโยชน์กับข้าพเจ้า
          </li>
          <li>
            ข้าพเจ้ายอมรับสิทธิประโยชน์ที่ทางสำนักงานฯ เสนอให้แก่ข้าพเจ้า
            โดยขึ้นอยู่กับนโยบายและเงื่อนไขของสำนักงานฯ ที่ข้าพเจ้าได้ยื่นคำขอ
            รวมทั้งข้อกำหนดและเงื่อนไขที่แก้ไขเพิ่มเติมในภายหน้าโดยมิต้องแจ้งให้กับข้าพเจ้าทราบล่วงหน้า
          </li>
          <li>
            ข้าพเจ้าได้ศึกษาและยอมรับเงื่อนไขการขอรับการช่วยเหลือหรืออุดหนุน
            ภายใต้มาตรการช่วยเหลือหรือการอุดหนุนของสำนักงานส่งเสริมเศรษฐกิจดิจิทัล
            (depa) รวมไปถึงกิจกรรมต่างๆ ของสำนักงานฯ ตามที่ได้ระบุไว้ตามประกาศ
            และเว็บไซต์ของสำนักงานฯ ที่ www.depa.or.th
          </li>
          <li>
            ข้าพเจ้าทราบและตกลงว่า สำนักงานฯ
            มีสิทธิ์ปฏิเสธการขอรับการช่วยเหลือหรืออุดหนุน
            ภายใต้มาตรการช่วยเหลือหรือการอุดหนุนของสำนักงานส่งเสริมเศรษฐกิจดิจิทัล
            (depa) รวมไปถึงกิจกรรมต่างๆ ของสำนักงานฯ
            โดยไม่จำเป็นต้องระบุเหตุแห่งการปฏิเสธ
          </li>
        </ol>
        <div class="cbterm">
          <v-checkbox
            v-model="cbTerm"
            label="ยอมรับเงื่อนไขและข้อตกลงในการขอรับการช่วยเหลือหรืออุดหนุน
            ภายใต้มาตรการช่วยเหลือหรือการอุดหนุนของสำนักงานส่งเสริมเศรษฐกิจดิจิทัล
            (depa) รวมไปถึงกิจกรรมต่างๆ ของสำนักงานฯ"
          >
          </v-checkbox>
        </div>
      </div>
    </div>
    <div style="flex-grow: 2" class="elevation-10 Kanit text-center py-3">
      <v-row dense class="px-2 mx-0">
        <v-col cols="6">
          <v-btn
            @click="cancel"
            outlined
            block
            color="grey"
            class="mr-2"
            dark
            style="font-size: 16px"
            >ยกเลิก</v-btn
          ></v-col
        >
        <v-col cols="6">
          <v-btn
            :disabled="!cbTerm"
            :dark="cbTerm"
            @click="agree"
            block
            depressed
            color="primary"
            style="font-size: 16px"
            >ยอมรับเงื่อนไข</v-btn
          >
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cbTerm: false,
    };
  },
  methods: {
    cancel() {
      this.$liff.closeWindow();
    },
    agree() {
      // localStorage.setItem("agreeTermDepa", true);
      this.query.view = "Registration";
    },
  },
};
</script>

<style lang="scss" >
p {
  margin-bottom: 0px !important;
}
.cbterm .v-input__slot {
  align-items: end !important;
}
</style>